import { CompanyRelationshipType } from '#/@types/backend'
import CowmedChip from '#/components/Chip'
import Colors from '#/styles/Colors'

type CompanyRelationshipTypeValue = {
  status: CompanyRelationshipType
  text: string
}

const TypeCompanyRelationship = ({ value }: { value?: CompanyRelationshipTypeValue }) => {
  if (!value) return <span>-</span>

  const { status, text } = value

  return <CowmedChip style={Colors.company_relationship[status]} value={text} width={'unset'} />
}

export { TypeCompanyRelationship }
